import { PageTypeProvider } from "./PageTypeProvider";

const TYPE_BY_PAGE_NAME_FRAGMENT_MAP = (() => {
	const typeByPageNameFragmentMap: Record<string, string> = {};
	typeByPageNameFragmentMap["Preview"] = "Preview";
	typeByPageNameFragmentMap["Index"] = "Question";
	typeByPageNameFragmentMap["Product Selection"] = "Product Selection";
	typeByPageNameFragmentMap["Payment"] = "Payment";
	return typeByPageNameFragmentMap;
})();

export class DefaultPageTypeProvider implements PageTypeProvider {
	constructor(
		private readonly typeByPageNameFragmentMap: Record<
			string,
			string
		> = TYPE_BY_PAGE_NAME_FRAGMENT_MAP
	) {
		// do nothing
	}

	getPageTypeByName(pageName: string | undefined): string {
		let pageType = "Unknown";
		if (pageName === undefined) return pageType;

		for (const pageNameFragment in this.typeByPageNameFragmentMap) {
			if (pageName.includes(pageNameFragment)) {
				pageType = this.typeByPageNameFragmentMap[pageNameFragment];
				break;
			}
		}

		return pageType;
	}
}
